module.exports = __webpack_public_path__ + "static/media/Payro1.a390e0c1.png";